<app-header></app-header>
<main class="pages blog-main">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="h1-title mt-3">Blog</h1>
                    <p class="sub-text mt-3">CViewSurvey Blogs focusses on keeping you updated with the latest survey trends, feedback tips and data analyzing strategies. </p>
                    <div class="mt-lg-5 mt-3">
                        <button class="btn btn-success btn-lg px-5 text-uppercase" type="button" data-toggle="modal" data-target="#callBack" id="callback">REQUEST A DEMO</button>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100" alt="Online and Offline Survey" src="assets/blog.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="blog-section py-lg-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <h4 class="font-weight-bold mb-lg-4">Recent Posts</h4>
                    <ul class="list-unstyled blog-list">
                        <li *ngFor="let blog of blogData; let i = index">
                            <div class="media mb-3 pb-3 border-bottom" (click)="blogNavigate(blog.id,blog.title,blog.view_count)" *ngIf=" i < 5 ">
                                <img class="img-fluid mr-3" *ngIf="blog.image == ''" src="assets/blog-default.jpg" alt="">
                                <img class="img-fluid mr-3" *ngIf="blog.image != ''" src="{{server}}{{blog.image}}" alt="">
                                <div class="media-body">
                                    <h5 class="mt-0 truncate-1">{{blog.title}}</h5>
                                    <p class="truncate-2 mb-0" [innerHTML]="blog.content"></p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-lg-9">
                    <div class="blogs-parent">
                        <div class="row">
                            <div class="col-lg-4 blog" *ngFor="let blog of blogData">
                                <div class="blog-card mb-3">
                                    <div class="card">
                                        <span class="category">
                                            {{blog.category}}
                                        </span>
                                        <img class="card-img-top" *ngIf="blog.image == ''" src="assets/blog-default.jpg" alt="">
                                        <img class="card-img-top" *ngIf="blog.image != ''" src="{{server}}{{blog.image}}" alt="">
                                        <div class="card-body">
                                            <h4 class="card-title truncate-1">{{blog.title}}</h4>
                                            <p class="card-text truncate-3" [innerHTML]="blog.content"></p>
                                            <a (click)="blogNavigate(blog.id,blog.title,blog.view_count)" class="btn btn-link p-0">Read More..</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    

                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>